import lodash from "lodash";
import store from '../store';
import axios from "axios";
import moment from 'moment';

const helpFunctions = {
    modal_functions: {
        openModal(ref) {
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
    },
    footer_props: {
        itemsPerPageOptions: [
            {value:15, title:'15'},
            {value:25, title:'25'},
            {value:50, title:'50'},
            {value:75, title:'75'},
            {value:100, title:'100'},
            {value:125, title:'125'},
            {value:150, title:'150'},
            {value:175, title:'175'},
            {value:200, title:'200'},
            {value:250, title:'250'},
            {value:300, title:'300'}
        ],
        itemsPerPageText: "Rows per page:",
    },
    table_options: {
        itemsPerPage: 15,
        page: 1,
        sortBy: [{"key": "id", "order": "asc"}],
        hide_expired_certificates: true,
        hide_closed_dossiers: true,
    },
    margins: {
        margin_top: 10,
        margin_bottom: 10,
        margin_left: 10,
        margin_right: 10,
    },
    field_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
        { value: "read_only", text: store.getters.translate("read_only") },
        { value: "link", text: store.getters.translate("link") },
    ],
    question_types: [
        { value: "text_field", text: store.getters.translate("text_field") },
        { value: "text_area", text: store.getters.translate("text_area") },
        { value: "boolean", text: store.getters.translate("boolean") },
        { value: "select_single", text: store.getters.translate("select_single") },
        { value: "select_multiple", text: store.getters.translate("select_multiple") },
        { value: "date", text: store.getters.translate("date") },
    ],
    date_periods: [
        { text: store.getters.translate('today'), value: 'today' },
        { text: store.getters.translate('yesterday'), value: 'yesterday' },
        { text: store.getters.translate('last_7_days'), value: 'last_7_days' },
        { text: store.getters.translate('last_30_days'), value: 'last_30_days' },
        { text: store.getters.translate('last_week'), value: 'last_week' },
        { text: store.getters.translate('last_month'), value: 'last_month' },
        { text: store.getters.translate('last_year'), value: 'last_year' },
        { text: store.getters.translate('this_week'), value: 'this_week' },
        { text: store.getters.translate('this_month'), value: 'this_month' },
        { text: store.getters.translate('this_year'), value: 'this_year' }
    ],
    pages: {
        actions: { name: "actions", model: "action" },
        assessors: { name: "assessors", model: "assessor" },
        candidates: { name: "candidates", model: "candidate" },
        certificates: { name: "certificates", model: "certificate" },
        companies: { name: "companies", model: "company" },
        contacts: { name: "contacts", model: "contact" },
        dashboard: { name: "dashboard", model: "dashboard" },
        dossiers: { name: "dossiers", model: "dossier" },
        employees: { name: "employees", model: "employee" },
        exams: { name: "exams", model: "exam" },
        examstatuses: { name: "examstatuses", model: "examstatus" },
        fields: { name: "fields", model: "field" },
        forms: { name: "forms", model: "form" },
        formquestions: { name: "formquestions", model: "formquestion" },
        home: { name: "home", model: "home" },
        locations: { name: "locations", model: "location" },
        modellogs: { name: "modellogs", model: "modellog" },
        notes: { name: "notes", model: "note" },
        notifications: { name: "notifications", model: "notification" },
        people: { name: "people", model: "people" },
        planner: { name: "planner", model: "planner" },
        profile: { name: "profile", model: "profile" },
        portal: { name: "portal", model:"portal" },
        questioncategories: { name: "questioncategories", model: "questioncategory" },
        roles: { name: "roles", model:"role" },
        rooms: { name: "rooms", model:"room" },
        schemeprices: { name: "schemeprices", model:"schemeprice" },
        schemesessions: { name: "schemesessions", model:"schemesession" },
        schemetrainings: { name: "schemetrainings", model:"schemetraining" },
        schemes: { name: "schemes", model:"scheme" },
        settings: { name: "settings", model: "setting" },
        tags: { name: "tags", model: "tag" },
        templates: { name: "templates", model: "template" },
        tokens: { name: "tokens", model: "token" },
        trainings: { name: "trainings", model:"training" },
        translations: { name: "translations", model: "translation" },
        triggers: { name: "triggers", model: "trigger" },
        workflows: { name: "workflows", model: "workflow" },
    },
    //NOT USED NOW. SHOULD BE REWRITTEN LATER
    dashboard_headers: [
        { title: store.getters.translate("name"), value: "candidate_name", align: "start", sortable: true },
        { title: store.getters.translate("exam"), value: "exam_name", align: "start", sortable: true },
        { title: store.getters.translate("date"), value: "examination_date", align: "start", sortable: true },
        { title: store.getters.translate("reference"), value: "reference", align: "start", sortable: true },
        { title: "Theorie", value: "theorie", align: "start", sortable: true },
        { title: "Praktijk", value: "praktijk", align: "start", sortable: true },
        { title: "Visuele inspectie", value: "visuele_inspectie", align: "start", sortable: true },
        { title: "Theorie scope 12", value: "theorie_scope_12", align: "start", sortable: true },
    ],
    job_queue_headers: [
        { title: store.getters.translate('id'), align: "start", sortable: true, value: 'id' },
        { title: store.getters.translate('name'), align: "start", sortable: true, value: 'name' },
        { title: store.getters.translate('date'), align: "start", sortable: true, value: 'date' }
    ],
    examstatuses_headers: [
        { title: store.getters.translate("id"), value: "id", align: "start", sortable: true },
        { title: store.getters.translate("name"), value: "name", align: "start", sortable: true },
        { title: store.getters.translate("location_name"), value: "location_name", align: "start", sortable: true },
        { title: store.getters.translate("joint_planning"), value: "joint_planning", align: "start", sortable: true },
        { title: store.getters.translate("location_requested"), value: "location_requested", align: "start", sortable: true },
        { title: store.getters.translate("location_agreed"), value: "location_agreed", align: "start", sortable: true },
        { title: store.getters.translate("practical_planned"), value: "practical_planned", align: "start", sortable: true },
        { title: store.getters.translate("examiner_requested"), value: "examiner_requested", align: "start", sortable: true },
        { title: store.getters.translate("examiner_agrees"), value: "examiner_agrees", align: "start", sortable: true },
        { title: store.getters.translate("passed_on_to_customer"), value: "passed_on_to_customer", align: "start", sortable: true },
        { title: store.getters.translate("stipel"), value: "stipel", align: "start", sortable: true },
        { title: store.getters.translate("running_projects"), value: "running_projects", align: "start", sortable: true },
        { title: store.getters.translate("plans_completed"), value: "plans_completed", align: "start", sortable: true },
    ],
    schemeprices_headers: [
        { title: store.getters.translate("id"), value: "id", align: "start", sortable: true },
        { title: store.getters.translate("name"), value: "name", align: "start", sortable: true },
        { title: "Session 1", value: "session_1", align: "start", sortable: true, width: '200px' },
        { title: "Session 2", value: "session_2", align: "start", sortable: true, width: '200px' },
        { title: "Session 3", value: "session_3", align: "start", sortable: true, width: '200px' },
        { title: "Session 4", value: "session_4", align: "start", sortable: true, width: '200px' },
        { title: store.getters.translate("course_price"), value: "course_price", align: "start", sortable: true },
        { title: '', align: "center", fixed: true, sortable: false, value: "actions", width: '80px' }
    ],
    base_table_includable_options: {
        assessors: {
            exams: {
                no_select: true,
            },
            rooms: {
                link: true,
                detachable: true,
            },
            schemes: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        candidates: {
            certificates: {
                deletable: true,
            },
            dossiers: {
                deletable: true,
            },
            exams: {
                link: true,
                detachable: true,
            },
            companies: {
                link: true,
                detachable: true,
            },
            contacts: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        companies: {
            contacts: {
                create: true,
                link: true,
                detachable: true,
            },
            candidates: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        contacts: {
            companies: {
                link: true,
                detachable: true,
            },
            candidates: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        dossiers: {
            notes: {
                create: true,
                deletable: true,
            }
        },
        employees: {
            roles: {
                link: true,
                detachable: true,
            },
            tokens: {
                create: true,
                deletable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        exams: {
            assessors: {
                no_select: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
        forms: {
            formquestions: {
                create: true,
                no_select: true,
            },
            questioncategories: {
                create: true,
                no_select: true,
            },
        },
        schemes: {
            schemesessions: {
                create: true,
                no_select: true,
            },
            schemetrainings: {
                create: true,
                no_select: true,
            },
            assessors: {
                link: true,
                detachable: true,
            },
            notes: {
                create: true,
                deletable: true,
            }
        },
    },
    true_checkbox: "<svg data-layer='53fdbc09-5421-4390-a26f-dd60a2515111' width='18' height='18' preserveAspectRatio='none' viewBox='2.999999523162842 2.999999523162842 25.999998092651367 26' class='icon-ready'><path fill='#008000' d='M 26.11111068725586 2.999999523162842 L 5.888888835906982 2.999999523162842 C 4.285554885864258 2.999999523162842 2.999999523162842 4.299999713897705 2.999999523162842 5.888888835906982 L 2.999999523162842 26.11111068725586 C 2.999999523162842 27.69999885559082 4.285554885864258 28.99999809265137 5.888888835906982 28.99999809265137 L 26.11111068725586 28.99999809265137 C 27.71444320678711 28.99999809265137 28.99999809265137 27.69999885559082 28.99999809265137 26.11111068725586 L 28.99999809265137 5.888888835906982 C 28.99999809265137 4.299999713897705 27.71444320678711 2.999999523162842 26.11111068725586 2.999999523162842 Z M 13.11111164093018 23.22222137451172 L 5.888888835906982 15.99999904632568 L 7.925554752349854 13.96333312988281 L 13.11111164093018 19.13444328308105 L 24.07444381713867 8.171111106872559 L 26.11111068725586 10.22222232818604 L 13.11111164093018 23.22222137451172 Z'></path></svg>",
    false_checkbox: "<svg data-layer='6e603f22-b4e4-4b9f-a319-a90a916d27dc' width='18' height='18' preserveAspectRatio='none' viewBox='2.999999523162842 2.999999523162842 25.999998092651367 26' class='icon-non'><path fill='#cc0000' d='M 26.11111068725586 2.999999523162842 L 5.888888835906982 2.999999523162842 C 4.299999713897705 2.999999523162842 2.999999523162842 4.299999713897705 2.999999523162842 5.888888835906982 L 2.999999523162842 26.11111068725586 C 2.999999523162842 27.69999885559082 4.299999713897705 28.99999809265137 5.888888835906982 28.99999809265137 L 26.11111068725586 28.99999809265137 C 27.69999885559082 28.99999809265137 28.99999809265137 27.69999885559082 28.99999809265137 26.11111068725586 L 28.99999809265137 5.888888835906982 C 28.99999809265137 4.299999713897705 27.69999885559082 2.999999523162842 26.11111068725586 2.999999523162842 Z M 23.22222137451172 17.44444274902344 L 8.777777671813965 17.44444274902344 L 8.777777671813965 14.55555534362793 L 23.22222137451172 14.55555534362793 L 23.22222137451172 17.44444274902344 Z'></path></svg>",
    //TABLES FUNCTIONS
    showRecords(all_records, response_fields, advanced_search) {
        let sorted_array = all_records;
        let field_names = Object.keys(response_fields);
        for (let i = 0; i < field_names.length; i++) {
            if(field_names[i] === 'tags_array') {
                sorted_array = advanced_search['tags_array'].length > 0 ? this.sortByTagsBase(sorted_array, advanced_search['tags_array']) : sorted_array;
            }
            else if (advanced_search[field_names[i]] !== undefined && advanced_search[field_names[i]] !== null && advanced_search[field_names[i]] !== "") {
                if(response_fields[field_names[i]] === 'boolean') {
                    sorted_array = sorted_array.filter(item => (item[field_names[i]] && advanced_search[field_names[i]]) || (!item[field_names[i]] && !advanced_search[field_names[i]]));
                }
                else {
                    sorted_array = sorted_array.filter(item => item[field_names[i]] && item[field_names[i]] !== "" && item[field_names[i]].toString().toLowerCase().includes(advanced_search[field_names[i]].toLowerCase()));
                }
            }
            if(sorted_array.length === 0) {
                break;
            }
        }
        return sorted_array;
    },
    //BASE TABLE AND BASE LINK FUNCTIONS
    sortByTagsBase(sorted_array, tags) {
        let response = [];
        for (let i = 0; i < sorted_array.length; i++) {
            if (sorted_array[i].tags_array && sorted_array[i].tags_array.length > 0) {
                let found = false;
                for (let x = 0; x < sorted_array[i].tags_array.length; x++) {
                    for (let y = 0; y < tags.length; y++) {
                        if (sorted_array[i].tags_array[x] === tags[y]) {
                            response.push(sorted_array[i]);
                            found = true;
                            break;
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
        }
        return response;
    },
    //UNIVERSAL FUNCTIONS
    getLocalStorageValue(value_name) {
        if (localStorage.getItem(value_name)) {
            return JSON.parse(localStorage.getItem(value_name));
        }
        return null;
    },
    setLocalStorageValue(value_name, value) {
        localStorage.setItem(value_name, JSON.stringify(value));
    },
    getBreadcrumbs(module_name, current = null) {
        let response = [{
            title: "Dashboard",
            disabled: false
        }];
        if(module_name !== "dashboard") {
            response[0].to = "/";
            response[1] = {
                title: store.getters.translate(module_name)
            }
            if(current == null) {
                response[1].disabled = true;
            }
            else {
                response[1].disabled = false;
                response[1].href = "/" + module_name;
                response[2] = {
                    title: current,
                    disabled: true
                }
            }
        }
        return response;
    },
    async getFields(model, action, disabled = false, without_auth = false) {
        await store.dispatch('setLoader', true);
        let additionalModels = {};
        let response;
        if(without_auth) {
            response = await axios.get(store.getters.appUrl + "v2/register/fields?" + action + "=true&model_type=" + model);
        }
        else {
            response = await axios.get(store.getters.appUrl + "v2/fields?" + action + "=true&model_type=" + model);
        }
        let data = response.data;
        let tags_required = false;
        let usual_fields = [];
        let custom_fields = [];
        let promises = [];
        for (let x = 0; x < data.length; x++) {
            if (data[x].custom_field == 1) {
                if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            text: store.getters.translate(data[x].available_options[i]),
                            value: data[x].available_options[i],
                        };
                    }
                }
                custom_fields.push(data[x]);
            }
            else if(data[x].name === 'tags') {
                tags_required = true;
            }
            else if(disabled) {
                data[x].name = data[x].name.replace('_id', '_name');
                if(data[x].field_type === 'select_single') {
                    data[x].field_type = 'text_field';
                }
                usual_fields.push(data[x]);
            }
            else {
                if(data[x].name === 'country_of_birth_id') {
                    if(!additionalModels.countries) {
                        if(without_auth) {
                            additionalModels.countries = this.getCountriesAndNationalitiesWithoutAuth("country", "country_id", ["country_name"]);
                        }
                        else {
                            additionalModels.countries = this.getAdditionalModelsForDropdowns("country", "country_id", ["country_name"]);
                        }
                        promises.push(additionalModels.countries);
                    }
                    data[x].available_options = additionalModels.countries;
                }
                else if(data[x].name === 'exam_id') {
                    if(!additionalModels.exams) {
                        additionalModels.exams = this.getAdditionalModelsForDropdowns("exam", "id", ["name"]);
                        promises.push(additionalModels.exams);
                    }
                    data[x].available_options = additionalModels.exams;
                }
                else if(data[x].name === 'form_id') {
                    if(!additionalModels.forms) {
                        additionalModels.forms = this.getAdditionalModelsForDropdowns("form", "id", ["name"]);
                        promises.push(additionalModels.forms);
                    }
                    data[x].available_options = additionalModels.forms;
                }
                else if(data[x].name === 'location_id') {
                    if(!additionalModels.locations) {
                        additionalModels.locations = this.getAdditionalModelsForDropdowns("location", "id", ["name"]);
                        promises.push(additionalModels.locations);
                    }
                    data[x].available_options = additionalModels.locations;
                }
                else if(data[x].name === 'nationality_id') {
                    if(!additionalModels.nationalities) {
                        if(without_auth) {
                            additionalModels.nationalities = this.getCountriesAndNationalitiesWithoutAuth("nationality", "nationality_id", ["nationality_name"]);
                        }
                        else {
                            additionalModels.nationalities = this.getAdditionalModelsForDropdowns("nationality", "nationality_id", ["nationality_name"]);
                        }
                        promises.push(additionalModels.nationalities);
                    }
                    data[x].available_options = additionalModels.nationalities;
                }
                else if(data[x].name === 'room_id') {
                    if(!additionalModels.rooms) {
                        additionalModels.rooms = this.getAdditionalModelsForDropdowns("room", "id", ["name"], " | ", "location_id");
                        promises.push(additionalModels.rooms);
                    }
                    data[x].available_options = additionalModels.rooms;
                }
                else if(data[x].name === 'scheme_id') {
                    if(!additionalModels.schemes) {
                        additionalModels.schemes = this.getAdditionalModelsForDropdowns("scheme", "id", ["name"]);
                        promises.push(additionalModels.schemes);
                    }
                    data[x].available_options = additionalModels.schemes;
                }
                else if(data[x].name === 'template_id') {
                    if(!additionalModels.templates) {
                        additionalModels.templates = this.getAdditionalModelsForDropdowns("template", "id", ["name"]);
                        promises.push(additionalModels.templates);
                    }
                    data[x].available_options = additionalModels.templates;
                }
                else if(data[x].name === 'user_id') {
                    if(!additionalModels.users) {
                        additionalModels.users = this.getAdditionalModelsForDropdowns("user", "id", ["name"]);
                        promises.push(additionalModels.users);
                    }
                    data[x].available_options = additionalModels.users;
                }
                else if(data[x].name === 'candidate_id') {
                    if(!additionalModels.candidates) {
                        additionalModels.candidates = this.getAdditionalModelsForDropdowns("candidate", "id", ["name"]);
                        promises.push(additionalModels.candidates);
                    }
                    data[x].available_options = additionalModels.candidates;
                }
                else if(data[x].field_type === 'select_single' || data[x].field_type === 'select_multiple') {
                    for (let i = 0; i < data[x].available_options.length; i++) {
                        data[x].available_options[i] = {
                            value: data[x].available_options[i],
                            text: store.getters.translate(data[x].available_options[i]),
                        };
                    }
                }
                usual_fields.push(data[x]);
            }
        }
        await Promise.all(promises);
        for (let x = 0; x < data.length; x++) {
            if (data[x].available_options && typeof data[x].available_options.then === 'function') {
                data[x].available_options = await data[x].available_options;
            }
        }
        await store.dispatch('setLoader', false);
        return { tags_required: tags_required, usual_fields: usual_fields, custom_fields: custom_fields };
    },
    composeFields(fields, add_actions_column) {
        let response = [];
        let field_names = Object.keys(fields);
        for (let i = 0; i < field_names.length; i++) {
            if(store.getters.getUser.is_admin || (field_names[i] !== 'mandatory' && field_names[i] !== 'show_in_portal' && field_names[i] !== 'show_on_creation' && field_names[i] !== 'show_on_update')) {
                const field = {
                    title: store.getters.translate(field_names[i]),
                    key: field_names[i],
                    align: "start",
                    fixed: true,
                    sortable: true,
                    value: field_names[i],
                };
                if (fields[field_names[i]] === 'date') {
                    field.sort = (a, b) => {
                        let dateA;
                        let dateB;
                        if(field_names[i] === 'created_at' || field_names[i] === 'updated_at' || field_names[i] === 'last_used_at') {
                            dateA = a ? moment(a).toDate() : null;
                            dateB = b ? moment(b).toDate() : null;
                        }
                        else {
                            dateA = a ? moment(a, 'DD-MM-YYYY', true).toDate() : null;
                            dateB = b ? moment(b, 'DD-MM-YYYY', true).toDate() : null;
                        }

                        // Fall back to new Date if Moment parsing fails
                        // No need to do it because we have only 2 cases:
                        // timestamp for created_at/updated_at and DD-MM-YYYY for everything else
                        /*if (dateA && isNaN(dateA.getTime())) {
                            dateA = a ? new Date(a) : null;
                        }
                        if (dateB && isNaN(dateB.getTime())) {
                            dateB = b ? new Date(b) : null;
                        }*/

                        if (!dateA || isNaN(dateA.getTime())) {
                            if (!dateB || isNaN(dateB.getTime())) {
                                return 0;
                            } else {
                                return -1;
                            }
                        } else if (!dateB || isNaN(dateB.getTime())) {
                            return 1;
                        } else {
                            return dateA.getTime() - dateB.getTime();
                        }
                    }
                }

                response.push(field);
            }
        }
        if (add_actions_column) {
            response.push({
                title: '',
                align: 'center',
                fixed: true,
                sortable: false,
                value: 'actions',
                width: '80px',
            });
        }
        return response;
    },
    async getCountriesAndNationalitiesWithoutAuth(model, option_id, option_name) {
        let models = [];
        const response = await axios.post(store.getters.appUrl + "v2/register/countries-and-nationalities", { model: model });
        let data = response.data.data ? response.data.data : response.data;
        data.forEach((option) => {
            let text = [];
            for (let i = 0; i < option_name.length; i++) {
                if(option[option_name[i]]) {
                    text.push(store.getters.translate(option[option_name[i]]));
                }
            }
            models.push({ value: option[option_id], text: text });
        });
        return lodash.sortBy(models, "text");
    },
    async getAdditionalModelsForDropdowns(model, option_id = "id", option_name = ["name"], separator = " | ", filter = null) {
        let models = [];
        const response = await axios.post(store.getters.appUrl + "v2/additional-models-for-dropdowns", { model: model, fields: option_name.join(), filter: filter });
        let data = response.data.data ? response.data.data : response.data;
        data.forEach((option) => {
            let text = [];
            for (let i = 0; i < option_name.length; i++) {
                if(option[option_name[i]]) {
                    text.push(store.getters.translate(option[option_name[i]]));
                }
            }
            let record = { value: option[option_id], text: text.join(separator) };
            if(filter) {
                record.filter = option[filter];
            }
            models.push(record);
        });
        return lodash.sortBy(models, "text");
    },
    async getOneFullAdditionalModel(toasted, model, id, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/get-one-additional-model", { model: model, id: id })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return {};
        }
    },
    async getFullAdditionalModels(toasted, model, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/additional-models-full", { model: model })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async getModelsForTables(toasted, model, additional_filter) {
        await store.dispatch('setLoader', true);
        let params = additional_filter ? "?source=site" + additional_filter : "?source=site";
        const response = await axios.get(store.getters.appUrl + "v2/" + model + params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
        else {
            return [];
        }
    },
    async loadModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.get(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            let result = response.data;
            let modelsWithCustomFields = ["assessors", "candidates", "contacts", "employees"];

            if (modelsWithCustomFields.includes(model)) {
                if (result.custom_fields == null || Array.isArray(result.custom_fields) || typeof result.custom_fields !== "object") {
                    result.custom_fields = {};
                }
            }
            return result;
        }
        return false;
    },
    async createModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data.id;
        }

        return false;
    },
    async createModelSilently(model, record) {
        const response = await axios.post(store.getters.appUrl + "v2/" + model, record);
        return response && response.status === 200;
    },
    async saveModel(toasted, model, record) {
        await store.dispatch('setLoader', true);
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    async saveModelSilently(model, record) {
        const response = await axios.patch(store.getters.appUrl + "v2/" + model + "/" + record.id, record);
        return response && response.status === 200;
    },
    async deleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async restoreModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/" + model_id + "/restore")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_restored"));
            return true;
        }

        return false;
    },
    async forceDeleteModel(toasted, model, model_id) {
        await store.dispatch('setLoader', true);
        const response = await axios.delete(store.getters.appUrl + "v2/" + model + "/" + model_id + "/delete")
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("successfully_deleted"));
            return true;
        }

        return false;
    },
    async getPDFFile(toasted, url, params) {
        await store.dispatch('setLoader', true);

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    async getFile(toasted, id) {
        await store.dispatch('setLoader', true);

        const response = await axios.get(store.getters.appUrl + "v2/files/" + id, { responseType: "blob" })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            return response.data;
        }
    },
    async saveFile(toasted, model, formData) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/uploadfiles", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return response.data;
        }
    },
    async deleteFile(toasted, model, params) {
        await store.dispatch('setLoader', true);
        const response = await axios.post(store.getters.appUrl + "v2/" + model + "/deletefiles", params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            })

        await store.dispatch('setLoader', false);

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }
    },
    async getCustomRoute(toasted, url, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.get(store.getters.appUrl + "v2/" + url)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            return response.data;
        }

        return false;
    },
    async postCustomRoute(toasted, url, params, show_success = false, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.post(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            if(show_success) {
                toasted.success(store.getters.translate("success"));
            }
            return response.data;
        }

        return false;
    },
    async patchCustomRoute(toasted, url, params, show_loading = false) {
        if(show_loading) {
            await store.dispatch('setLoader', true);
        }

        const response = await axios.patch(store.getters.appUrl + "v2/" + url, params)
            .catch((error) => {
                toasted.error(error.response?.data?.error ?? error.message);
                return false;
            });

        if(show_loading) {
            await store.dispatch('setLoader', false);
        }

        if (response && response.status === 200) {
            toasted.success(store.getters.translate("success"));
            return true;
        }

        return false;
    },
    modelFieldsFilled(toasted, record, fields, ignore_fields = []) {
        let status = true;
        for (let i = 0; i < fields.length; i++) {
            if ((fields[i].name === 'first_name' || fields[i].name === 'last_name') && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate('name'));
                status = false;
            }
            else if (fields[i].mandatory && !ignore_fields.includes(fields[i].name) && fields[i].field_type !== 'boolean' && (!record[fields[i].name] || record[fields[i].name] === '')) {
                toasted.error(store.getters.translate("required_field") + ": " + store.getters.translate(fields[i].name));
                status = false;
            }
        }
        return status;
    },
    replaceIDwithNameBaseTable(fields) {
        let new_fields = {};
        for (const key of Object.keys(fields)) {
            if(key === 'status') {
                new_fields['status_name'] = fields[key];
            }
            else if(key === 'tags') {
                new_fields['tags_array'] = fields[key];
            }
            else if(key !== 'auditable_id' && key !== 'country_of_birth_id' && key !== 'nationality_id') {
                new_fields[key.replace('_id', '_name').replace('_by', '_by_name')] = fields[key];
            }
            else {
                new_fields[key] = fields[key];
            }
        }
        return new_fields;
    },
    replaceIDwithNameBaseTableInc(name) {
        if(name !== 'auditable_id' && name !== 'country_of_birth_id' && name !== 'nationality_id') {
            name = name.replace('_id', '_name').replace('_by', '_by_name');
        }
        return name;
    },
    replaceLastChar(model) {
        if(model === 'company') {
            return 'companies';
        }
        else {
            return model + "s";
        }
    },
    uid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    },
}

export default helpFunctions